import { motion } from "framer-motion";
import { Clapperboard, CalendarDays, Users, BarChart3 } from "lucide-react";
import { STATS } from "@/constants/aero";

const ICONS = {
  clapperboard: Clapperboard,
  calendar: CalendarDays,
  users: Users,
  chart: BarChart3,
};

export const StatsBar = () => (
  <section data-testid="stats-bar" className="bg-white border-y border-ink/5">
    <div className="max-w-[1500px] mx-auto px-6 md:px-10 grid grid-cols-2 lg:grid-cols-4">
      {STATS.map((s, i) => {
        const Icon = ICONS[s.icon];
        return (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.6, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
            data-testid={`stat-${s.icon}`}
            className={`flex items-center gap-5 py-9 ${i > 0 ? "lg:border-l lg:border-ink/8 lg:pl-10" : ""} ${i % 2 === 1 ? "border-l border-ink/8 pl-6 lg:pl-10" : ""}`}
          >
            <Icon size={30} strokeWidth={1.4} className="text-ink shrink-0" />
            <div>
              <p className="font-display font-extrabold text-3xl md:text-4xl text-ink leading-none">{s.value}</p>
              <p className="mt-2 font-mono text-[12px] tracking-[0.18em] uppercase text-neutral-500">{s.label}</p>
            </div>
          </motion.div>
        );
      })}
    </div>
  </section>
);
